// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2p6rM","header":"ReportDetails_header__2dKnf","title":"ReportDetails_title__UyP1T","left":"ReportDetails_left__2pKxj"};